<template>
    <div class="px-0">
        <v-container class="px-0" style="max-width: 100% !important">
            <v-row class="px-3 pb-2 mt-1" >
                <v-col sm="8" md="4" class="py-0">
                    <v-text-field
                        v-model="props.search"
                        append-icon="search"
                        :label="$t('totes.search')"
                        single-line
                        hide-details
                        class="mb-4 py-0 px-2 mt-0 tools-view-height"
                        style="background-color: var(--v-white_highlight-base); border: 1px solid black; border-radius:5px"
                    ></v-text-field>
                </v-col>
                <v-spacer></v-spacer> 
                <v-col cols="4" align="end" class="py-0">
                    <v-row class="mx-0 my-0 px-0 py-0" justify="end">
                        <v-btn class="right white_highlight--text tools-view-height" color="secondary" :to="'/totes/create'" v-permission="'tote.create'">
                            {{ $t('totes.new') }}
                        </v-btn>
                    </v-row>
                </v-col>
            </v-row>
            <v-card class="px-0 size_buttons">
                <v-card-text class="py-3">
                    <v-row>
                        <v-col class="py-0">
                            <datatable :props="{headers:headers, items: props.items, search:props.search}" @methodHandler="methodHandler"></datatable>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>

            <v-dialog v-model="modalDetail" persistent max-width="90%">
                <v-card >
                    <v-card-title class="justify-center">
                        <v-row align="center" justify="center">
                            <h4 class="text-uppercase blue_accent--text py-2">
                                {{ $t('totes.header') }} {{ this.tote.id }}
                            </h4>
                        </v-row>
                    </v-card-title>
                    
                    <div class="marker1-1" style="font-weight:bold"><label class="mx-1">{{ $t('totes.details') }}</label></div>
                    <div class="detail_content1"><label style="font-weight:bold">{{ $t("totes.name") }}</label> <label>{{ this.tote.name }}</label></div>
                    <div class="detail_content1" v-if="tote.shipment_id != null"><label style="font-weight:bold">{{ $t("totes.shipment_id") }}</label> <label>{{ this.tote.shipment_id }}</label></div>
                    <div class="detail_content1" v-if="tote.shipment_type != null"><label style="font-weight:bold">{{ $t("totes.shipment_type") }}</label> <label> {{ this.tote.shipment_type }} </label></div>
                                         
                    <div class="marker1-1 mt-2 detail_content1" style="font-weight:bold;"><label class="mx-1">{{ $t('totes.slot') }}</label></div>
                    <span>
                        <div class="detail_content1" v-if="tote.slot != null"><label style="font-weight:bold">{{ $t("totes.name") }}</label> <label> {{ this.tote.slot.name }} </label></div>
                        <div class="detail_content1" v-if="tote.slot != null"><label style="font-weight:bold">{{ $t("totes.station") }}</label> <label> {{ this.tote.slot.station_id }} </label></div>
                    </span>

                    <v-card-text class="mt-5">
                        <div class="d-flex">
                            <v-spacer></v-spacer>
                            <v-btn color="secondary" class="white_highlight--text" @click="modalDetail = false">
                                {{ $t('totes.close') }}
                            </v-btn>
                        </div>
                    </v-card-text> 
                    <div class="marker1"></div>
                </v-card>
            </v-dialog>
            </v-container>     
        <v-snackbar v-model="snackbar.visible" :timeout="4000" :color="snackbar.color" style="text-align: center; color: var(--v-accent-base);">{{ snackbar.text }}</v-snackbar>
    </div>
</template>

<script>
import { HttpToteRepository } from "../infrastructure/tote_repository";
import { toteIndexUseCase } from "../application/use_cases/tote_index_use_case";
import { toteShowUseCase } from "../application/use_cases/tote_show_use_case";
import { toteDownloadLabelUseCase } from "../application/use_cases/tote_download_label_use_case";
import FileSaver from "file-saver";

export default {
    computed: {
        headers(){
            return [
                { text: this.$t('totes.id'), align: "center", value: 'id', class: 'text-uppercase' }, 
                { text: this.$t('totes.name'), align: "center", value: 'name', class: 'text-uppercase' },
                { text: this.$t('totes.shipment_id'), align: "center", value: 'shipment_id', class: 'text-uppercase' },
                { text: this.$t('totes.shipment_type'), align: "center", value: 'shipment_type', class: 'text-uppercase' },
                { text: this.$t('totes.actions'), align: "center", value: 'actions', class: 'text-uppercase' }
            ];
        } 
    },
    data(){
        return {
            snackbar: {
                visible: false,
                color: 'primary',
                text: ''
            },
            modalDetail: false,
            idTote: '',
            tote: {
                "id": "",
                "name": "",
                "user": {
                    "id": "",
                    "email": "",
                    "warehouse_id": "",
                    "name": "",
                    "paternal_surname": ""
                },
                "warehouse": {
                    "id": "",
                    "name": ""
                },
                "slots": []
            },
            props: {
                search: '',
                items: [],
            }
        }
    },
    mounted(){
        this.index();
        this.$store.state.module = "headers.totes";
    },
    methods: {
        methodHandler(object){
            this[object.methodName](object.parameters)
        },
        async index(){
            try{
                this.props.items = [];
                const result = await toteIndexUseCase(HttpToteRepository);
                this.props.items = result;
            }catch(e){
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data.fault.message
                }
            }
        },
        async show(tote){
            try{
                const result = await toteShowUseCase(tote.id, HttpToteRepository);
                this.tote = result;
                this.modalDetail = true;
            }catch(e){
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data.fault.message
                }
            }
        },
        async downloadLabel(tote){
            try {
                const result = await toteDownloadLabelUseCase(tote.id, HttpToteRepository);

                const base64WithoutPrefix = result.label.split(',')[1];

                const byteCharacters = atob(base64WithoutPrefix);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);

                const mimeType = result.label.match(/^data:(.*);base64/)[1];

                const blob = new Blob([byteArray], { type: mimeType });

                FileSaver.saveAs(blob, "Tote_label-" + tote.id + ".png");
            } catch(e){
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data.fault.message
                }
            }
        }
    }
}
</script>

<style>

</style>